import { connect } from 'react-redux'
import * as selector from '../../state/basis/selector'
import * as action from '../../state/basis/action'
import BasisReport from './BasisReport'

const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
        setReport: selector.calculateSetReport(state),
        treatmentByOrder: selector.calculateTreatmentByOrder(state),
        treatmentByPayment: selector.calculateTreatmentByPayment(state),
    }
}

const mapDispatchToProps = {
    fetchBasisReport: action.fetchBasisReport,
}

export default connect(mapStateToProps, mapDispatchToProps)(BasisReport)



// WEBPACK FOOTER //
// ./src/modules/analytics/component/basis/BasisReportContainer.js